declare namespace $ {

	export class $bog_fragile_demo_collide_base1 extends $mol_view {
		title( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=base1.view.tree.d.ts.map